module.exports = __webpack_public_path__ + "img/xskj-title.7aa06768.png";